import * as React from 'react'
import CommonContext, { CommonContextType } from '../CommonContext'
import { UserShape } from '../../api/api_data_types'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../helpers/queryClient'
import TravelListTableWithFilter from "./TravelListTableWithFilter";

type TravelListAppProps = {
  currentUser: CommonContextType['currentUser']
  availableUsers: UserShape[]
}

export default function TravelListApp({ currentUser, availableUsers }: TravelListAppProps) {
  const queryClient = buildQueryClient()
  const dictionaries: CommonContextType = {
    currentUser,
    availableUsers,
  }
  return (
    <CommonContext.Provider value={dictionaries}>
      <QueryClientProvider client={queryClient}>
        <TravelListTableWithFilter />
      </QueryClientProvider>
    </CommonContext.Provider>
  )
}
